import { NavLink } from "react-router-dom";

function DrawerMenu({ isOpen, onClose }) {
    return (
        <div className={`drawer-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
            <div
                className={`drawer-menu ${isOpen ? "open" : ""}`}
                onClick={(e) => e.stopPropagation()}
            >
                <button className="drawer-close" onClick={onClose}>
                    ×
                </button>

                <nav className="drawer-links">
                    <NavLink to="/" className="drawer-link" onClick={onClose}>
                        Acasa
                    </NavLink>
                    <NavLink to="/despre" className="drawer-link" onClick={onClose}>
                        Despre
                    </NavLink>
                    <NavLink to="/antrenori" className="drawer-link" onClick={onClose}>
                        Antrenori
                    </NavLink>
                    <NavLink to="/abonamente" className="drawer-link" onClick={onClose}>
                        Abonamente
                    </NavLink>
                    <NavLink to="/galerie" className="drawer-link" onClick={onClose}>
                        Galerie
                    </NavLink>
                    <NavLink to="/contact" className="drawer-link" onClick={onClose}>
                        Contact
                    </NavLink>
                </nav>

                <NavLink to="/contact" className="drawer-cta" onClick={onClose}>
                    Inscrie-te
                </NavLink>
            </div>
        </div>
    );
}

export default DrawerMenu;